import {Component, Inject} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {IdexService} from '../../idex.service';

@Component({
   selector: 'app-reject-task-dialog',
   templateUrl: './reject-task-dialog.component.html',
   styleUrls: ['./reject-task-dialog.component.css']
})
export class RejectTaskDialogComponent {

   public rejectReason;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
               public service: IdexService,
               private dialogRef: MatDialogRef<RejectTaskDialogComponent>) {
   }

   ok() {
      this.dialogRef.close(this.rejectReason);
   }

}
